import * as Sentry from "@sentry/browser";

const dsn = import.meta.env.VITE_SENTRY_DSN;
const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT || 'local';
const enabled = import.meta.env.VITE_SENTRY_ENABLED === 'true';

if (dsn && enabled) {
    Sentry.init({
        dsn,
        environment,
        enableLogs: true,
    });
}
